import cn from 'classnames';
import { MatchFilterConfig } from '@repo/types/';
import { useSearchParams } from 'react-router';

export type CompetitionSwitcherProps = {
  isMobile: boolean;
  matchFilters: MatchFilterConfig[];
  selectedCompetition?: MatchFilterConfig;
};

export function CompetitionSwitcher({ selectedCompetition, matchFilters }: CompetitionSwitcherProps) {
  const [searchParams] = useSearchParams();
  const query = new URLSearchParams();

  searchParams.forEach((value, key) => {
    if (key !== 'competition' && key !== 'team') {
      query.set(key, value);
    }
  });

  return (
    <ul className="competition-switcher">
      {matchFilters.map((matchFilter) => {
        const currentQuery = new URLSearchParams(query);
        currentQuery.set('competition', matchFilter.competitions);

        return (
          <li key={matchFilter.label}>
            <a
              className={cn('competition-switcher__link', {
                'competition-switcher__link--active': selectedCompetition?.competitions === matchFilter.competitions,
              })}
              href={`?${currentQuery.toString()}`}
            >
              {matchFilter.label}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
